<app-navigation>
  <h1 class="welcome-title">Welcome to the Realist User Guide!</h1>
  <p class="text-description">
    <span class="d-block">Here you will learn to use Realist to compete effectively with</span>
    best-in-class functionality along with integrated tax and MLS data.
  </p>
</app-navigation>
<section class="d-flex w-100 home-section">
  <app-home-item *ngFor="let homeItem of homeItems" [item]="homeItem"></app-home-item>
</section>
